export default function Footer(){
    const year = new Date().getFullYear();
    return(
        <footer>
        © {year} Shelly Group. All Rights Reserved.
        </footer>
    )
}